<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色可授权的角色范围。</span
        >如果需要进行二次授权时，可选择的角色范围包含: 下方列表中勾选的角色和用户自行创建的角色。
      </div>
    </div>
    <div class="table_contain">
      <!-- 下部table -->
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="44"></el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :formatter="item.formatter"
          :width="item.width"
          :show-overflow-tooltip="true"
          :label="item.label"
        />
      </el-table>
    </div>
    <el-pagination
      class="text-right mt20"
      background
      layout="prev, pager, next, jumper, total"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      :current-page="currentPage"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { PAGE_SIZE, PAGE_SIZES } from '@/lib/constants';
import Axios from '@/lib/axios';
export default {
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      tableColumn: [
        {
          prop: 'encodeDeviceId',
          label: '角色名称'
        },
        {
          prop: 'encodeDeviceId',
          label: '角色类型'
        },
        {
          prop: 'deviceName',
          label: '创建用户'
        },
        {
          prop: 'deviceName',
          label: '创建时间'
        },
        {
          prop: 'deviceName',
          label: '更新时间'
        },
        {
          prop: 'deviceName',
          label: '描述'
        }
      ],
      selectedApplicationIndex: 0,
      multipleSelection: [],
      pageSize: PAGE_SIZE,
      pageSizes: PAGE_SIZES,
      currentPage: 1,
      total: 0,
      tableData: []
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.handleQuery(val);
    },

    // 查询列表
    handleQuery(val) {
      this.currentPage = val || 1;
      const that = this;
      Axios.requestWWWForm({
        url: '/unicom/encodeDevice/searchPage',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          pageSize: that.pageSize,
          pageNo: that.currentPage
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            let currentdata = res.data;
            that.total = currentdata.totalCount;
            that.tableData = currentdata.result;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    //单选框
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
}

.table_contain {
  border: 1px solid rgba(230, 230, 230, 1);
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}
</style>
